/**
 * Plugin client : charge Matomo (exemption CNIL) et restaure le consentement cookies pour activer les autres tags si déjà acceptés.
 * @returns {void}
 */
export default defineNuxtPlugin((): void => {
  const { hydrateFromStorage } = useAnalyticsConsent()
  hydrateFromStorage()
})
